import { all, select, takeLatest } from 'redux-saga/effects';

// Constants:
import { INIT_APP } from '../../../store/view/constants';

// Helpers:
import { dataLayerPush, dataLayerPushParams } from '../../../helpers/gtm';

// Selectors:
import {
  selectOrderID,
  getPaymentAmount,
} from '../../../store/payment/selectors';
import { getIsTyping } from '../store/view/selectors';

// Actions:
import { finishPayment, setPaymentAmount } from '../../../store/payment/slice';
import { createCertificateSuccessAction } from '../store/certificate/sagaActions';

const CATEGORY = {
  GIFT: 'gift',
};

function onInitApp() {
  try {
    dataLayerPush({
      event: 'ccx-pageview',
      browser: window.navigator.userAgent,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Can not push ccx-pageview', error);
  }
}

function* onChangeGiftValue() {
  const isTyping = yield select(getIsTyping);
  const value = yield select(getPaymentAmount);

  if (isTyping) return;

  dataLayerPushParams({ order_sum: value });
}

function* onOrderCreatedSuccess() {
  const orderId = yield select(selectOrderID);

  dataLayerPushParams({ order_id: orderId });

  dataLayerPush({
    event: 'order_created',
    eventCategory: CATEGORY.GIFT,
  });
}

function onPaymentSuccess() {
  dataLayerPush({
    event: 'order_paid',
    eventCategory: CATEGORY.GIFT,
  });
}

export default function* analyticsSagas() {
  yield all([
    takeLatest(INIT_APP, onInitApp),
    takeLatest([INIT_APP, setPaymentAmount], onChangeGiftValue),
    takeLatest(createCertificateSuccessAction, onOrderCreatedSuccess),
    takeLatest(finishPayment, onPaymentSuccess),
  ]);
}
